const videoKinds = {
  AWS_LIVESTREAM: 1,
  AWS_VOD: 2,
  EMBED: 3,
  MULTI_EMBED: 4,
};

export default videoKinds;
